/** ReportsRoute — skin-aware switcher for /reports. */
import { useUISkin } from "@/data/UISkinContext";
import Reports from "./Reports";
import ReportsCockpit from "./ReportsCockpit";
export default function ReportsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ReportsCockpit />;
  return <Reports />;
}
